// Une RUBRIQUE du profil d'une fiche de poste (« Compétences primordiales : »)
// — même règle que le serveur (utils/jobDescription.estRubriqueProfil) : une
// ligne courte, sans puce, terminée par « : ». Elle s'affiche en sous-titre,
// jamais en puce (vécu 20.10, besoin 270 : les primordiales se perdaient).
export const estRubrique = (ligne) => /^[^▪•\-*–].{2,68}:\s*$/.test(String(ligne || '').trim());
export const libelleRubrique = (ligne) => String(ligne || '').trim().replace(/\s*:\s*$/, '');
